import prod from './pro'
import staging from './staging'
import dev from './dev'

let currentConfig = dev

if (process.env.NODE_ENV === 'staging') {
  currentConfig = staging
} else if (process.env.NODE_ENV === 'production') {
  currentConfig = prod
}

export default currentConfig
